import {Timer} from '@fantasmagames/core/src/update/Timer';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';
import {SpinButtonModule} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonModule';
import {GameSpinButtonWhileSpinningState} from 'src/spinbutton/states/GameSpinButtonWhileSpinningState';
import {FlowModuleEvents} from '@fantasmagames/slot/src/modules/flow/FlowModuleEvents';

export class GameSpinButtonModule extends SpinButtonModule {
	public static readonly REGULATION_SPIN_DELAY_PASSED: string = 'GameSpinButtonModule::REGULATION_SPIN_DELAY_PASSED';

	protected _regulationSpinTimer: Timer;
	protected _spinTimeRegulation: number = 0;
	protected _regulationCanSpin: boolean = true;
	protected _warningPopupOpen: boolean = false;

	public init(): void {
		super.init();

		this.setupCertificationSettings();
	}

	public hasSpinTimeRegulation(): boolean {
		return this._spinTimeRegulation !== 0;
	}

	public startRegulationSpinTimer(): void {
		this._regulationSpinTimer = new Timer(
			() => {
				this._regulationCanSpin = true;
				this.currentState.handle(GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED);
			},
			this._spinTimeRegulation,
			true,
		);
		this.updateManager.add(this._regulationSpinTimer);
	}

	protected setupCertificationSettings(): void {
		this._spinTimeRegulation = 0;
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.onCurrentStateHandle(FlowModuleEvents.CAN_CONTINUE_SPIN);
		this.onCurrentStateHandle(GameSpinButtonModule.REGULATION_SPIN_DELAY_PASSED);
	}

	protected tryEnableKeyboardInput(): void {
		if (!this._warningPopupOpen && !this._infoPopupOpen && !this._autoplayMenuOpen) {
			this._isKeyboardInputEnabled = true;
		}
	}

	protected setupStates(): void {
		super.setupStates();

		this.addState(new GameSpinButtonWhileSpinningState(this, SpinButtonModule.REELS_SPINNING_STATE));
	}

	protected onSpinButtonClicked(): void {
		super.onSpinButtonClicked();

		this.soundPlayer.play('spinStart');
	}

	protected onAutoplayStopClicked(): void {
		this.eventManager.emit(SpinButtonEvents.STOP_AUTOPLAY_BUTTON_PRESSED);
		if (this.logic.freeSpinsLeft <= 0) {
			this.view.uninitAutoplay();
		}

		this._isInAutoplay = false;
	}

	public set regulationCanSpin(value: boolean) {
		this._regulationCanSpin = value;
	}

	public get regulationCanSpin(): boolean {
		return this._regulationCanSpin;
	}
}



// WEBPACK FOOTER //
// ./src/spinbutton/GameSpinButtonModule.ts